/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */

import PaletteIconCheckbold from '@telus-uds/palette-allium/build/rn/icons/Checkbold'
const theme = {
  appearances: {},
  rules: [],
  tokens: {
    background: '#2c2e30',
    checkMarkFocusColor: '#676e73',
    checkMarkHeight: 24,
    checkMarkHoverColor: '#676e73',
    checkMarkIcon: PaletteIconCheckbold,
    checkMarkSelectedColor: '#ffffff',
    checkMarkUnselectedColor: 'rgba(0, 0, 0, 0)',
    checkMarkWidth: 24,
    padding: 16
  }
}
export default theme
